import { Component, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { NSUnitTrainConstants } from '@ruby/configs/unit-train.constants';
import { IUnitTrainFilters, IUTFiltersConfigurations } from '@ruby/modules/unit-train/models/unit-train.interface';
import { fromUTAdvanceSearch, UTAdvanceSearchActions, UTAdvanceSearchSelectors } from '@ruby/modules/unit-train/store/ut-advance-search.index';
import { PermitDetailDialog } from '@ruby/shared/dialogs/unit-train/permit-detail/components/permit-detail.dialog';
import { TrainConsistContainer } from '@ruby/shared/dialogs/unit-train/train-consist/containers/train-consist.container';
import { ViewPermitContainer } from '@ruby/shared/dialogs/unit-train/view-permit/containers/view-permit.container';
import { EMapEnums } from '@ruby/shared/enums/map.enums';
import { IShipmentAttributes } from '@ruby/shared/models/shipments/shipments.interface';

@Component({
  selector: 'ng-ut-results-map-container',
  templateUrl: './ut-results-map.container.html',
  styleUrls: ['./ut-results-map.container.scss']
})
export class UTResultsMapContainer implements OnDestroy {
  filtersConfigs: Partial<IUTFiltersConfigurations> = NSUnitTrainConstants.mappingFiltersConfiguration;
  store$: Observable<fromUTAdvanceSearch.State>;

  constructor(private store: Store<fromUTAdvanceSearch.State>, private matDialog: MatDialog) {
    this.store$ = store.select(UTAdvanceSearchSelectors.selectUTAdvanceSearchState);
  }

  ngOnDestroy(): void {
    this.store.dispatch(UTAdvanceSearchActions.resetAdvanceSearchState());
  }

  /**
   * Make Advance Search
   *
   * @summary Will make a search
   * @param $filters: IUnitTrainFilters
   * @return void
   */
  makeAdvanceSearch($filters: IUnitTrainFilters): void {
    this.store.dispatch(UTAdvanceSearchActions.getShipments({ data: $filters }));
  }

  /**
   * Clear Route
   *
   * @summary Clear Route
   * @return void
   */
  clearRoute(): void {
    this.store.dispatch(UTAdvanceSearchActions.clearTrace());
  }

  /**
   * View Route
   *
   * @summary View Route
   * @param $params: IShipmentAttributes
   * @return void
   */
  viewRoute($params: IShipmentAttributes): void {
    this.store.dispatch(UTAdvanceSearchActions.getTraces({
      data: { trainSa: $params.trainNumber, shipmentId: $params.shipmentId }
    }));
  }

  /**
   * View Permit
   *
   * @summary View Permit
   * @param $params: IShipmentAttributes
   * @return void
   */
  viewPermit($params: IShipmentAttributes): void {
    const config: MatDialogConfig = {
      data: { permitNo: $params.permitNumber, permitId: $params.permitId, permitType: $params.leInd },
      width: '90vw',
      height: '90vh',
      autoFocus: false
    };
    ($params.leInd === EMapEnums.LOAD) ? this.matDialog.open(PermitDetailDialog, config) : this.matDialog.open(ViewPermitContainer, config);
  }

  /**
   * View Train Consist
   *
   * @summary View Train Consist
   * @param $params: IShipmentAttributes
   * @return void
   */
  viewTrainConsist($params: IShipmentAttributes): void {
    const [traceCarInit, traceCarNumber] = $params.traceCar.split(' ');
    this.matDialog.open(TrainConsistContainer, {
      data: {
        traceCarInit,
        traceCarNumber,
        permitId: $params.permitId,
        shipmentId: $params.shipmentId
      },
      width: '70%',
      height: '60%'
    });
  }
}
